<template>
  <div>
    <component
      :is="componentName"
      v-for="person in merged"
      :key="person.id"
      :[attribute]="person"
      v-bind="attrs"
    >
      <template #personNameAdditionalDetails>
        <slot name="personNameAdditionalDetails" v-bind="{ person }" />
      </template>
      <template #personAdditionalDetails>
        <slot name="personAdditionalDetails" v-bind="{ person }" />
      </template>
    </component>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";
import AppShowPersonWithDetails from "@AppShows/person/AppShowPersonWithDetails.vue";
import AppShowAthleteName from "@AppShows/person/AppShowAthleteName.vue";
import AppShowPersonNameWithIdentifiers from "@AppShows/person/AppShowPersonNameWithIdentifiers.vue";
import PersonRegistrationMerge from "@/utils/personRegistrationMerge";

export default {
  name: "AppShowRegistrationPeople",
  components: {
    AppShowPersonName,
    AppShowPersonWithDetails,
    AppShowAthleteName,
    AppShowPersonNameWithIdentifiers
  },
  props: {
    componentName: {
      type: String,
      required: true,
      validate(val) {
        return [
          "AppShowAthleteName",
          "AppShowPersonName",
          "AppShowPersonWithDetails",
          AppShowPersonNameWithIdentifiers
        ].includes(val);
      }
    },
    people: {
      type: Array,
      required: true
    },
    registrationPeople: {
      type: Array,
      required: true
    },
    attrs: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    attribute() {
      switch (this.componentName) {
        case "AppShowAthleteName":
          return "athlete";
        default:
          return "person";
      }
    },
    merged() {
      return PersonRegistrationMerge(this.people, this.registrationPeople);
    }
  },
  fragments: {
    athlete: gql`
      fragment _ on Person {
        id
        ${AppShowAthleteName.fragments.athlete}
        licenceCategoryId
        licenceCategory @client {
          id
          name
        }
        clubName
      }
    `,
    person: gql`
      fragment _ on Person {
        id
        ${AppShowPersonWithDetails.fragments.person}
        clubName
      }
    `,
    personName: gql`
      fragment _ on Person {
        id
        ${AppShowPersonName.fragments.person}
      }
    `,
    personWithIdentifiers: AppShowPersonNameWithIdentifiers.fragments.person,
    registrationPerson: gql`
      fragment _ on RegistrationPerson {
        id
        personId
        registrationId
        personLicenceCategoryId
        personLicenceCategory @client {
          id
          name
        }
        personClubOrganisationId
        personClubOrganisation {
          id
          shortName
          name
        }
      }
    `
  }
};
</script>
